import { FormState } from 'react-hook-form'

type UseScrollToError = <T>(formState: FormState<any>) => void

const useScrollToError: UseScrollToError = () => {
	// useEffect(() => {
	// const { errors } = formState
	// if (!errors) {
	// return
	// }
	// const errorsValues = Object.values(errors)
	// if (!errorsValues.length || !errorsValues) {
	// return
	// }
	// const firstErrorValue = [...errorsValues].shift()
	// const error = Object.values(firstErrorValue).shift() as FieldError
	// const firstErrorElement = document.querySelector(
	// 	`[name^="${error.ref?.name}"]`
	// )
	// if (!firstErrorElement) {
	// }
	// TODO бэклог сделать
	// firstErrorElement.scrollIntoView({ behavior: `smooth`, block: 'center' })
	// }, [formState])
}

export default useScrollToError
